import styled from "styled-components";
import media from "styled-media-query";

import vector from '../../assets/vector-illustration-down.jpg'
import polygon from '../../assets/icon-polygon.svg'

export const SectionManual = styled.section`
  position: relative;
  background-color: #144BC8;
  padding: 43px 0 138px;

  ${media.lessThan('1024px')`
    padding: 67px 30px 36px;
  `}
  ${media.lessThan('690px')`
    padding-top: 27px;
  `}

  ${media.greaterThan('1024px')`
    background-image: url(${vector});
    background-position: bottom;
    background-size: contain;
  `}

  .container {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    max-width: 1478px;
    margin-right: 75px;
    margin-left: auto;
    padding: 0;

    ${media.between('1024px', '1366px')`
      max-width: 1048px;
      margin-right: 85px;

      button {
        max-width: 306px;
        height: 60px;
        font-size: 18px;
      }
    `}

    ${media.lessThan('1024px')`{
      flex-direction: column;
      justify-content: initial;
      align-items: center;
      padding: 0;
    `}
  }

  .list-manual {
    color: #fff;
    h2 {
      width: 100%;
      max-width: 773px;
      font-style: normal;
      font-weight: 900;
      font-size: 44px;
      line-height: 54px;

      ${media.lessThan('1366px')`
        font-size: 30px;
        line-height: 29px;
      `}

      ${media.lessThan('1024px')`
        font-size: 24px;
        line-height: 29px;
      `}
    }

    & > p {
      margin: 33px 0 59px;
      font-style: normal;
      font-weight: 500;
      font-size: 25px;
      max-width: 780px;
      line-height: 30px;

      ${media.lessThan('1366px')`
        font-size: 18px;
        line-height: 22px;
      `}

      ${media.lessThan('1024px')`
        margin: 27px 0 33px;
        font-size: 16px;
        line-height: 20px;
      `}
    }
    
    .list {
      margin-bottom: 75px;
      list-style: none;
      ${media.lessThan('1024px')`
        margin-bottom: 0;
      `}

      li {
        font-style: normal;
        font-weight: 600;
        font-size: 21px;
        line-height: 30px;
        margin: 0;
        position: relative;
        padding-left: 60px;

        

        &::before {
          content: '';
          display: inline-block;
          position: absolute;
          background-image: url(${polygon});
          background-size: contain;
          left: 5px;
          width: 38px;
          height: 38px;
          top: -4px;
          ${media.lessThan('1366px')`
            width: 32px;
            height: 32px;
            top: -7px;
            left: 13px;
          `}

          ${media.lessThan('1024px')`
            width: 32px;
            height: 32px;
            top: -1px;
            left: 5px;
          `}
        }

        & + li {
          margin-top: 48px;
          ${media.lessThan('1024px')`
            margin-top: 22px;
          `}
        }
        h3 {
          font-weight: 900;
          display: block;
          margin-bottom: 24px;
          ${media.lessThan('1366px')`
            line-height: 25px;
            font-size: 18px;
          `}
          ${media.lessThan('1024px')`
            margin-bottom: 14px;
            font-size: 18px;
          `}
        }

        p {
          ${media.lessThan('1366px')`
            line-height: 22px;
            font-size: 18px;
          `}
          ${media.lessThan('1024px')`
            font-size: 16px;
          `}
        }
      }
    }

    ${media.greaterThan('1024px')`
        padding-left: 20px;
    `}

    ${media.lessThan('1024px')`
        margin-bottom: 54px;
    `}
  }

  .illustration-manual {
    width: 100%;
    min-width: 298px;
    max-width: 649px;
    ${media.lessThan('1366px')`
      max-width: 460px;
      align-self: flex-start;
    `}

    ${media.greaterThan('1024px')`
        padding-right: 20px;
        margin-left: 54px;
    `}
    ${media.lessThan('1024px')`
      align-self: center;
    `}
  }
`